const API_BASE = process.env.REACT_APP_API_BASE_URL;

export async function getAdminUsers({
  accessToken,
  category,
  search = "",
  region = "ALL",
  authStatus = "ALL",
  ordering = "RECENTLY_UPDATED",
  page = 1,
  signal,
}) {
  const params = new URLSearchParams({
    category,
    region,
    auth_status: authStatus,
    ordering,
    page: String(page),
  });

  if (search.trim()) {
    params.set("search", search.trim());
  }

  const response = await fetch(
    `${API_BASE}/api/admin/users/?${params.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
      },
      signal,
    },
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data?.detail || "Could not load administrator users.");
  }

  return data;
}
